import React, { Component } from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
export default class BackgroundColorPicker extends Component {
    constructor(props){
        super(props);
        this.state ={
            displayColorPicker: false,
             color:props.fBackgroundColor
        }
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
      };
    
      handleClose = () => {
        this.setState({ displayColorPicker: false })
      };
    
      handleChange = (color) => {
        this.props.handleBackground(color.hex);
        this.setState({ color: color.hex })
      };

      resetClick = ()=>{
        this.setState({ color: 'transparent' },()=>{this.props.handleBackground(this.state.color)})
      }
     
  render() {
    const styles = reactCSS({
        'default': {
          color: {
            width: '15px',
            height: '15px',
            borderRadius: '2px',
            background:this.state.color,
            border:'1px solid #bababa'

          },
          swatch: {
            padding: '5px 5px',
            background: '#fff',
            display: 'inline-block',
            cursor: 'pointer',
            textAlign:'center',
            fontSize:'18px',
            border:'none',
            borderRadius:'5px',
            marginTop:'3px',
            marginBottom:'3px'
          },
          popover: {
            position: 'absolute',
            zIndex: '2',
          },
          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
          },
          plr:{
            position:'relative'
          }
        },
      });
      return (
        <div style={styles.plr}>
          <div style={ styles.swatch } onClick={ this.handleClick }>
            <div style={ styles.color } />
            
          </div>
          <button onClick={this.resetClick} className="resetBtn2"><KeyboardBackspaceIcon style={{fontSize:'15px'}}/></button>
          { this.state.displayColorPicker ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClose }/>
            <div className='popBox'>
            <SketchPicker color={ this.props.fBackgroundColor } onChange={ this.handleChange } />
           
            </div>
          
          </div> : null }
  
        </div>
      )
    }
  
}
